interface IResult {
  status: boolean
  text: string
}

const checkErrorEight = (locationUrl: string): IResult => {
  const statusError: boolean = locationUrl.includes('code=13')
  const errorOrder: boolean =
    locationUrl.includes('error=133') || locationUrl.includes('error=169')
  const text1: string =
    'Превышен лимит попыток оплаты' +
    '<br/>' +
    'по карте, попробуйте оплатить другой' +
    '<br/>' +
    'картой или обратитесь' +
    '<br/>' +
    'к администратору заведения '
  const text2 =
    'Время жизни оплаты заказа истекло. <br/> Пожалуйста попробуйте оплатить еще раз'
  return {
    status: statusError || errorOrder,
    text: statusError ? text1 : text2
  }
}

export default checkErrorEight
